import { useEffect, useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";
import ResourceAdmin from "./ResourceAdmin";

export function AdminStandings() {
    return (
        <ResourceAdmin
            title="Standings"
            resource="standings"
            listKey="team_name"
            emptyValues={{ conference: "Western", wins: 0, losses: 0, is_self: false, sort_order: 0 }}
            fields={[
                { key: "team_name", label: "Team Name" },
                { key: "conference", label: "Conference", type: "select", options: ["Western", "Eastern"] },
                { key: "wins", label: "Wins", type: "number" },
                { key: "losses", label: "Losses", type: "number" },
                { key: "is_self", label: "Is Purple Kings?", type: "boolean", help: "Mark this row as our team (highlighted)" },
                { key: "sort_order", label: "Sort Order", type: "number" },
            ]}
        />
    );
}

export function AdminPressAssets() {
    return (
        <ResourceAdmin
            title="Press Assets"
            resource="press-assets"
            listKey="title"
            imageField="file_url"
            emptyValues={{ kind: "photo", is_published: true, sort_order: 0 }}
            fields={[
                { key: "title", label: "Title" },
                { key: "kind", label: "Kind", type: "select", options: ["logo", "photo", "doc", "video"] },
                { key: "description", label: "Description", type: "textarea" },
                { key: "file_url", label: "File / Image", type: "image" },
                { key: "sort_order", label: "Sort Order", type: "number" },
                { key: "is_published", label: "Published", type: "boolean" },
            ]}
        />
    );
}

export function AdminMediaInquiries() {
    const [items, setItems] = useState([]);
    const load = () => api.get("/media-inquiries").then((r) => setItems(r.data));
    useEffect(() => { load(); }, []);

    const setStatus = async (id, status) => {
        try { await api.put(`/media-inquiries/${id}/status?status=${status}`); toast.success("Updated"); load(); }
        catch (err) { toast.error(formatErr(err)); }
    };

    return (
        <div data-testid="admin-media-inquiries">
            <div className="text-gold text-[10px] tracking-[0.4em] uppercase font-bold mb-2">Newsroom</div>
            <h1 className="h-display text-4xl mb-8">Media Inquiries ({items.length})</h1>
            <div className="space-y-3">
                {items.map((m) => (
                    <div key={m.id} className="card-flat p-5" data-testid={`mi-${m.id}`}>
                        <div className="flex justify-between flex-wrap gap-2">
                            <div>
                                <div className="text-gold text-[10px] tracking-[0.3em] uppercase font-bold">{m.outlet}</div>
                                <div className="h-display text-lg mt-1">{m.name}</div>
                                <div className="text-ink text-xs mt-1">{m.email} {m.phone && `· ${m.phone}`}</div>
                                {m.deadline && <div className="text-gold text-xs mt-2">Deadline: {m.deadline}</div>}
                            </div>
                            <select value={m.status} onChange={(e) => setStatus(m.id, e.target.value)} className="text-xs px-2 py-1 h-fit">
                                <option value="new">new</option><option value="replied">replied</option><option value="closed">closed</option>
                            </select>
                        </div>
                        <p className="text-white/80 mt-3 leading-relaxed whitespace-pre-line text-sm">{m.message}</p>
                    </div>
                ))}
                {items.length === 0 && <div className="card-flat p-12 text-center text-ink">No inquiries yet.</div>}
            </div>
        </div>
    );
}
